import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';

import InfoModal from '@exchange/libs/modals/src/lib/common/InfoModal.vue';

type Action = {
  action: string;
  actionFn: () => void;
  actionTestId: string;
};

type Actions = [Action, Action, Action] | [Action, Action];


export default /*#__PURE__*/_defineComponent({
  __name: 'ForbiddenJurisdictionModal',
  props: {
    canNotifyMe: { type: Boolean },
    hasOptedToBeNotified: { type: Boolean }
  },
  emits: ["contact-support", "logout", "notify-me"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const contactSupportAction: Action = {
  action: 'ui.forbiddenJurisdictionModal.secondaryAction',
  actionFn: () => emit('contact-support'),
  actionTestId: 'contact-support',
};

const logoutAction: Action = {
  action: 'modules.auth.logout',
  actionFn: () => emit('logout'),
  actionTestId: 'logout',
};

const notifyMeAction: Action = {
  action: 'ui.forbiddenJurisdictionModal.primaryAction',
  actionFn: () => emit('notify-me'),
  actionTestId: 'notify-me',
};

const actions = computed((): Actions => (props.canNotifyMe ? [notifyMeAction, contactSupportAction, logoutAction] : [contactSupportAction, logoutAction]));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InfoModal, {
    testid: "forbidden-jurisdiction-modal",
    "content-test-id": "forbidden-jurisdiction-modal-content",
    variant: "dark",
    "no-icon": true,
    wide: actions.value.length > 2,
    title: 'ui.forbiddenJurisdictionModal.title',
    message: 'ui.forbiddenJurisdictionModal.message',
    action: actions.value[0].action,
    "action-disabled": props.hasOptedToBeNotified,
    "action-test-id": actions.value[0].actionTestId,
    "action-secondary": actions.value[1]?.action,
    "action-secondary-test-id": actions.value[1]?.actionTestId,
    "action-tertiary": actions.value[2]?.action,
    "action-tertiary-test-id": actions.value[2]?.actionTestId,
    onActionClicked: actions.value[0].actionFn,
    onActionSecondaryClicked: actions.value[1]?.actionFn,
    onActionTertiaryClicked: actions.value[2]?.actionFn
  }, null, 8, ["wide", "action", "action-disabled", "action-test-id", "action-secondary", "action-secondary-test-id", "action-tertiary", "action-tertiary-test-id", "onActionClicked", "onActionSecondaryClicked", "onActionTertiaryClicked"]))
}
}

})